$(document).ready(function () {

    var expandableFocusText = $(".module-focustext-content-expandable-container");

    if (expandableFocusText.length > 0) {

        expandableFocusText.each(function () {

            var expandableFocusTextItem = this;
            var expandableText = $(".module-focustext-content-expandable", expandableFocusTextItem);

            if (expandableText.innerHeight() > 220) {

                expandableText.css("max-height", "180px").wrap("<div class=\"module-focustext-content-expandable-overlay-wrap\"></div>").after("<span class=\"module-focustext-content-expandable-overlay\"></span>");

                var expandableTextButton = $(".module-focustext-content-expand-button", expandableFocusTextItem);

                expandableTextButton.on('click', function (event) {
                    event.preventDefault();
                    expandableText.css("max-height", "100%");
                    $(expandableFocusTextItem).addClass("module-focustext-content-expandable-expanded");
                    expandableTextButton.hide();
                    $(".module-focustext-content-expandable-overlay", expandableFocusTextItem).hide();
                });

                expandableTextButton.show();
            }
        })
    }
});